import React from "react";
import { createUseStyles } from "react-jss";
import Container from "reactstrap/lib/Container";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "row",
	},
	filterWrapper: {},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			flexDirection: "column",
		},
		filterWrapper: {
			marginLeft: "-20px",
			marginRight: "-20px",
		},
	},
}));

const FilterInfo = ({ filterElement, additionalInfo }) => {
	const classes = useStyles();

	return (
		<Container>
			<div className={classes.root}>
				{/* TODO: remove '<Container>' using from application/componentsUI/Filters/FiltersLayout/index.js because component cannot be reused normally */}
				<div className={classes.filterWrapper}>{filterElement}</div>
				{additionalInfo}
			</div>
		</Container>
	);
};

export default FilterInfo;
